<template>
	<component
		:is="type || 'button'"
		v-on="$listeners"
		:disabled="disabled"
		:href="href"
		:target="target"
		:class="[
			'el-button',
			variantClass,
			disabled ? '-disabled' : null,
		]"
	>
		<span
			class="button-text"
			v-html="text"
		/>
	</component>
</template>

<script>

export default {
	name: 'ElButton',
	props: {
		variant: {
			type: String,
			description: 'Sets the visual variant of the object.',
			default: null
		},
		text: {
			type: String,
			description: 'Text inside the component.',
			required: true
		},
		disabled: {
			type: Boolean,
			description: 'If `true`, disables the component.',
			default: false
		},
		type: {
			type: String
		},
		href: {
			type: String
		},
		target: {
			type: String
		}
	},
	computed: {
		variantClass() {
			return this.variant && this.variant != null ? '-variant-' + this.variant : null;
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/sass/variables";

$color-disabled: #AFB9C1;
$transition: .3s ease-out;

// mixin for creating alternate button themes
@mixin button-theme(
	$name,
	$background-color, $border-color, $text-color
) {
	&.-variant-#{$name} {
		background-color: $background-color;
		border-color: $border-color;
		color: $text-color;
		transition: $transition;
		transition-property: color, border-color, background-color;

		&:hover:not([disabled]) {
			background-color: $background-color;
			border-color: lighten( $color-text, 10% );
			color: lighten( $color-text, 10% );
		}

		@content;
	}
}

.el-button {
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: 1.8rem;
	letter-spacing: 1px;
	text-transform: uppercase;

	color: $color-white;
	background-color: $color-main;

	width: 30rem;
	height: 6rem;
	padding: 0;
	border-radius: $border-radius;
	border: .2rem solid transparent;
	transition: $transition;
	transition-property: color, background-color, border-color;

	display: flex;
	justify-content: center;
	align-items: center;

	cursor: pointer;

	> .button-text {
		display: block;
		flex: 1 0 0;
	}

	&.-disabled {
		cursor: not-allowed;
		background-color: $color-disabled;

		&:focus {
			outline: none;
		}
	}

	&:not([disabled]) {
		&:hover,
		&:active {
			background-color: lighten( $color-main, 10% )
		}
	}

	@include button-theme(
		'secondary',
		transparent, $color-text, $color-text
	);
}
</style>
